<template>
  <ul class="nav nav-md flex-column fs-14">
    <draggable class="dragArea list-group w-full" :list="treeList1" @change="changeSort">
      <!-- <template #item="{ element:tree, index }"> -->
      <!-- v-for="(tree, index) in treeList1" -->
      <!-- draggable="true" @dragstart="() => onDragStart(index, tree)"
        @dragover.prevent="onDragOver(index, tree)" @drop="onDrop()" -->
      <li v-for="(tree) in treeList1" :key="tree.id" class="nav-item treeMenu">
        <b-form-radio :class="['ms-0 mt-0', tree.showBg && 'filter']" name="some-radios" v-model="selectedId"
          :value="tree.id" @click.stop="handlerChange(tree.id)">
          <a :href="`#tree${tree.id}`" :id="tree.id" data-bs-toggle="collapse" role="button" aria-expanded="false"
            :aria-controls="tree.id" :data-key="tree.title" :style="{
              marginLeft:
                tree.num == 1
                  ? tree.num + 'rem'
                  : (0.5 + tree.num) + 'rem',
              fontWeight: '400',
              fontSize: '14px',
              display: 'flex',
              position: 'relative',
              width: 200 - (tree.num - 1) * 20 + 'px',
              height: '100%',
            }" class="text-dark align-items-center" @click.stop="(event) => handlerToggleIcon(event, tree.id)">
            <div class="d-flex align-items-center">
              <!-- <i
              v-if="tree.children && tree.children.length != 0"
              class="ri-indeterminate-circle-line text-info me-1"
            ></i> -->
              <!-- 通过父 id展开来判断小图标显示 -->
              <!-- || (tree.destination_market_list && tree.destination_market_list.length) -->
              <i v-if="(tree.children && tree.children.length != 0)" class="text-info me-1"
                :class="fatherIdList.includes(tree.id) ? 'ri-indeterminate-circle-line' : 'ri-add-circle-line'"></i>
            </div>
            <!-- && (!tree.destination_market_list || tree.destination_market_list.length ==0) -->
            <div :class="['d-flex flex-1 tree-cont', ((!tree.children || tree.children.length == 0)) && 'ms-3']">
              <div :style="{
                width: 200 + (tree.num - 1) * 10 + 'px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }">
                <!-- tree.destination_market_node || tree.show_title  ? tree.title : tree.destination_market ? tree.destination_market : -->
                {{
                  i18n.global.locale == 'en' ? tree.title_en : tree.title
                }}
              </div>

            </div>
          </a>
          <img :src="dragSvg" style="width: 11px;height: 16px;" class="me-2" />
        </b-form-radio>
        <!-- <div :class="['mt-0', tree.showBg && 'filter']" v-else class="form-check " style="margin-left: 15px;">
        <a :href="`#tree${tree.id}`" data-bs-toggle="collapse" role="button" aria-expanded="false"
          :aria-controls="tree.id" :data-key="tree.title" :style="{
            marginLeft:
              tree.num == 1
                ? tree.num + 'rem'
                : (0.5 + tree.num) + 'rem',
            fontWeight: '400',
            fontSize: '14px',
            display: 'flex',
            position: 'relative',
            width: 200 - (tree.num - 1) * 20 + 'px',
            height: '100%',
          }" class="text-dark align-items-center" @click.stop="handlerToggleIcon">
          <div>
            <i v-if="(tree.children && tree.children.length != 0)" class="text-info me-1"
              :class="fatherIdList.includes(tree.id) ? 'ri-indeterminate-circle-line' : 'ri-add-circle-line'"></i>
          </div>
          <div :class="['d-flex flex-1 tree-cont', ((!tree.children || tree.children.length == 0)) && 'ms-3']">
            <div :style="{
              width: 200 + (tree.num - 1) * 10 + 'px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }">
              {{ tree.destination_market_node || tree.show_title ? tree.title : tree.destination_market ? tree.destination_market :
              tree.title }}
            </div>
          </div>
        </a>
      </div> -->

        <div :class="fatherIdList.includes(tree.id) ? ['collapse', 'show'] : ['collapse', 'hide']"
          :id="`tree${tree.id}`" v-if="tree.children">
          <LeftMenu :treeList="tree.children" :selected="selected" :fatherIdList1=fatherIdList
            @getUserDetail="handlerChange">
          </LeftMenu>
        </div>

        <!-- <div :class="fatherIdList.includes(tree.id) ? ['collapse', 'show'] : ['collapse', 'hide']" :id="`tree${tree.id}`"
        v-if="tree.destination_market_list">
        <LeftMenu :treeList="tree.destination_market_list" :selected="selected" :fatherIdList1=fatherIdList
          @getUserDetail="handlerChange"></LeftMenu>
      </div> -->
      </li>
      <!-- </template> -->
    </draggable>
  </ul>
</template>

<script>
import LeftMenu from "./LeftMenu";
import i18n from "@/i18n"
import dragSvg from "@/assets/images/svg/drag.svg"
import { VueDraggableNext } from 'vue-draggable-next'
export default {
  data() {
    return {
      selectedId: "", //当前选择节点id
      fatherIdList: [], //存储当前选择id的父级id list 用来展开选择节点的所有父节点
      i18n,
      // draggingIndex: 0,
      treeList1: [],
      dragSvg,
      dragOptions: {
        group: 'items',
        animation: 200,
      },
    };
  },
  inject:['sortTree'], // 注入父组件的sortTree方法
  props: {
    treeList: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: String,
      default: "",
    },
    fatherIdList1: {
      type: Array,
      // default: ()=>[],
    },
  },
  emits: ["getUserDetail", 'sortTree'],
  components: {
    LeftMenu,
    draggable: VueDraggableNext
  },
  computed: {},
  watch: {
    selected: {
      handler(val) {
        this.selectedId = val;
      },
      immediate: true,
    },
    fatherIdList1: {
      handler(val) {
        if (val) {
          this.fatherIdList = val;
        }

      },
      immediate: true,
    },
    treeList: {
      handler(val) {
        this.treeList1 = val;
        // console.log(val);
      },
      immediate: true,
    }
  },
  methods: {
    findSiblingsById(tree, targetId) {
      // 查找目标节点的兄弟节点
      let result = [];
      function dfs(nodes) {
        for (const node of nodes) {
          if (node.children) {
            const found = node.children.find(child => child.id === targetId);
            if (found) {
              result = node.children;
              return;
            } else {
              dfs(node.children);
            }
          }
        }
      }
      dfs(tree);
      // 说明目标节点在根节点层级
      if (result.length === 0) {
        result = tree.filter(node => node.id === targetId || tree.some(n => n.id === targetId));
      }

      return result;
    },
    changeSort(movedNode) {
      // 结束
      let newList = this.findSiblingsById(this.treeList1, movedNode.moved?.element?.id)
      // // 先设置一下index
      // newList.forEach((item, index) => {
      //   item.index = index;
      // });
      // 传递
      // this.$emit('sortTree', newList)
      this.sortTree(newList);
    },
    // onDragStart(index, tree) {
    //   // 拖拽开始
    //   if (tree.num > 1) return
    //   this.draggingIndex = index;
    // },

    // onDragOver(index, tree) {
    //   if (tree.num > 1) return
    //   // 拖拽结束
    //   if (this.draggingIndex !== index) {
    //     const draggedItem = this.treeList1.splice(this.draggingIndex, 1)[0];
    //     this.treeList1.splice(index, 0, draggedItem);
    //     this.draggingIndex = index;
    //     // 传递
    //     this.$emit('sortTree', this.treeList1)
    //   }
    //   // 移除所有dragging
    //   setTimeout(() => {
    //     document.querySelectorAll('.dragging').forEach(el => el.classList.remove('dragging'));
    //   }, 10000)
    // },

    // onDrop() {
    //   // 离开
    //   this.draggingIndex = null;
    // },

    handlerToggleIcon(event, id) {
      /* ri-add-circle-line  */
      // let classList = event.target.offsetParent.firstChild.firstChild.classList;
      let classList = event.target.offsetParent.firstChild.firstElementChild.classList;
      console.log(document.getElementById(id).classList);
      let classList1 = document.getElementById(id).classList.value;
      // 新方法
      if (classList1.includes('collapsed')) {
        classList.remove("ri-indeterminate-circle-line");
        classList.add("ri-add-circle-line");
      } else {
        classList.add("ri-indeterminate-circle-line");
        classList.remove("ri-add-circle-line");
      }
      // if (classList1) {
      //   if ([...classList].includes("ri-indeterminate-circle-line")) {
      //     classList.remove("ri-indeterminate-circle-line");
      //     classList.add("ri-add-circle-line");
      //   } else {
      //     classList.add("ri-indeterminate-circle-line");
      //     classList.remove("ri-add-circle-line");
      //   }
      // }
    },
    handlerChange(id) {
      this.selectedId = id;
      this.$emit("getUserDetail", this.selectedId);
    },
  },
};
</script>
<style scoped lang='scss'>
ul {
  padding: 0;
}

.treeMenu {
  .form-check {
    border-bottom: 1px #e9ebec solid;
    margin: 0;
    display: flex;
    align-items: center;

    :deep(label) {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .tree-cont {
      line-height: 40px;
    }

    &.hilight {
      background: rgba(102, 145, 231, 0.15);
    }

    &.filter {
      background: rgba(41, 156, 219, 0.3);
    }
  }

  .rotate {
    transform: rotate(90deg);
  }
}
</style>
